import importerStore from '@shared/importer/importer-store';
import { TeamService } from '@modules/team/team-service';
import teamImporterFields from '@modules/team/team-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  TeamService.import,
  teamImporterFields,
  i18n('entities.team.importer.fileName'),
  i18n('entities.team.importer.hint'),
);
